 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","8":"source~bet-details-page~betting-history-page","9":"source~i18n-widgets-ar-json","10":"source~i18n-widgets-en-json","11":"source~i18n-widgets-fa-json","12":"source~i18n-widgets-tr-json","15":"source~/esports-betting-rules-TR","16":"source~bet-builder-rules-DE","17":"source~bet-builder-rules-EN","18":"source~bet-builder-rules-ES","19":"source~bet-builder-rules-ES-MX","20":"source~bet-builder-rules-ET","21":"source~bet-builder-rules-FI","22":"source~bet-builder-rules-FR","23":"source~bet-builder-rules-IT","24":"source~bet-builder-rules-JA","25":"source~bet-builder-rules-KA","26":"source~bet-builder-rules-LT","27":"source~bet-builder-rules-LV","28":"source~bet-builder-rules-PL","29":"source~bet-builder-rules-PT-BR","30":"source~bet-builder-rules-RO","31":"source~bet-builder-rules-RU","32":"source~bet-builder-rules-SQ","33":"source~bet-builder-rules-TR","34":"source~bet-details-page","35":"source~betting-history-container","36":"source~betting-history-page","37":"source~betting-rules-DA","38":"source~betting-rules-DE","39":"source~betting-rules-EN","40":"source~betting-rules-ES","41":"source~betting-rules-ES-MX","42":"source~betting-rules-FR","43":"source~betting-rules-IT","44":"source~betting-rules-JA","45":"source~betting-rules-PL","46":"source~betting-rules-PT","47":"source~betting-rules-PT-BR","48":"source~betting-rules-RO","49":"source~betting-rules-RU","50":"source~betting-rules-SQ","51":"source~betting-rules-TR","52":"source~bonus-info","53":"source~cashout-terms-AR","54":"source~cashout-terms-DA","55":"source~cashout-terms-DE","56":"source~cashout-terms-EN","57":"source~cashout-terms-ES","58":"source~cashout-terms-ES-MX","59":"source~cashout-terms-ET","60":"source~cashout-terms-FI","61":"source~cashout-terms-FR","62":"source~cashout-terms-IT","63":"source~cashout-terms-JA","64":"source~cashout-terms-KA","65":"source~cashout-terms-KU","66":"source~cashout-terms-LT","67":"source~cashout-terms-LV","68":"source~cashout-terms-PL","69":"source~cashout-terms-PT","70":"source~cashout-terms-PT-BR","71":"source~cashout-terms-RO","72":"source~cashout-terms-RU","73":"source~cashout-terms-SQ","74":"source~cashout-terms-SR","75":"source~cashout-terms-TR","76":"source~esports-betting-rules-DA","77":"source~esports-betting-rules-DE","78":"source~esports-betting-rules-EN","79":"source~esports-betting-rules-ES","80":"source~esports-betting-rules-ES-MX","81":"source~esports-betting-rules-ET","82":"source~esports-betting-rules-FI","83":"source~esports-betting-rules-FR","84":"source~esports-betting-rules-IT","85":"source~esports-betting-rules-JA","86":"source~esports-betting-rules-KA","87":"source~esports-betting-rules-LT","88":"source~esports-betting-rules-LV","89":"source~esports-betting-rules-PL","90":"source~esports-betting-rules-PT","91":"source~esports-betting-rules-PT-BR","92":"source~esports-betting-rules-RO","93":"source~esports-betting-rules-RU","94":"source~esports-betting-rules-SQ","95":"source~esports-betting-rules-SR","97":"source~generated-mappings","98":"source~i18n-ar-json","99":"source~i18n-en-json","100":"source~i18n-fa-json","101":"source~i18n-tr-json","103":"source~settings-page","104":"source~streaming-carousel","105":"source~virtual-esports-betting-rules-EN","106":"source~virtual-esports-betting-rules-IT","107":"source~virtual-esports-betting-rules-JA","108":"source~virtual-esports-betting-rules-PL","110":"vendors~rc-slider","111":"vendors~react-google-recaptcha","112":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"cd830ae42abd7b12e9a5","1":"e1eba0000e3ce5fcb1df","2":"cfc5844b09abbba561fb","3":"de9ebc35c2e1d704babe","4":"9c7ebe6ee6a7a5ca07d7","5":"bedf25a6f0080ce84203","6":"29f30f02584386ebd93e","8":"35616d3d84fc28732a27","9":"9e4d5a2b2afd31d696cb","10":"c2a86e3b20465904a5bd","11":"240da56dad92ed305eb9","12":"abd58c4374d190170150","15":"d94173b292bf6631d2cf","16":"d9ec8c621b2a5b57fe7e","17":"66d749caa52f1ace9cdb","18":"1e5de6752c3e069bb278","19":"01a256f9869a38f8b610","20":"e4cf6aaa68c1f802a739","21":"0b2aa78191eb73c5d85c","22":"9fd41e63173e3f232605","23":"ddeeb3ca23dfd002ae6e","24":"2213161ddb224f3d9ea1","25":"5aef7269f6d9e4319fa6","26":"ebfca94698cfb58aad2d","27":"b78f38bdee818726234a","28":"23d988cba49002c61015","29":"8e92fc95838deb6c168c","30":"4c744b73e654fea941b9","31":"526c1db6fb6021a58598","32":"f606f5553b1379e9c421","33":"a701224b09b0390753d6","34":"1adfd6a30b6dace5f0f7","35":"4d754b53186f04956128","36":"0c241872324c89cac740","37":"e0bbedcfb58cd5eec6c9","38":"c052d2ded41f3c29ee57","39":"a6762ada36ffd590a53e","40":"118e75eef5be2493cdad","41":"ed241bae043a03771ae7","42":"323ac93fbf6d6db323c5","43":"cca7fbb807a1191b13b4","44":"0eb86e4d5cdb87429908","45":"ad6e54faf01a104c36bb","46":"60e3edd57f1f15e88e2d","47":"8aef1a1a3ee04812ab40","48":"683350768db9fb6d032f","49":"1d5740b7ef3241293ed5","50":"dcc1dc2472192fbc97c0","51":"d4dcdc56a48425923a2b","52":"f1864cb6dd242edaa699","53":"5d47622fb0a17bf9664b","54":"2855b2988a1d0c6adee3","55":"468fe749497e24d88589","56":"447e605198119936ae25","57":"c848517f872019d79b69","58":"2e6d3cecf1dc461c8c6d","59":"1e0ae17d1e5732af8720","60":"d042119801e0f64eec2a","61":"de534b1226b439b94c22","62":"5529acf91a34446feb1c","63":"f91cc79c2dcb267417b8","64":"2348b25973ea92948a56","65":"bf714f970f797590e0d5","66":"01bf6e1edf9657a0e54a","67":"d2225f4e6ea2edd89ff3","68":"6e802c9722f881e8bbb7","69":"e72c51febf16a2fb1e9e","70":"f87785fe4c101f3d73b8","71":"d23abbf5f2dc0690dec4","72":"4837f90a50bb0bdfa12b","73":"246dcea4de489a439ea1","74":"a3f3b2115dba47e8c72b","75":"6603be431363d724d07c","76":"d3fc7d2dadaae3d0a921","77":"82b43702a9f636ebdc46","78":"d1faa6d46a7d8cafc71c","79":"b5ec18fb950c734c34f3","80":"dc6286a8aa92b689d0e7","81":"e8f33e8d90a22981b977","82":"4f088c033f911d581450","83":"1f7f2632a9c9d8f70ad2","84":"e2b6578a48bbb43d953e","85":"f88a9899f34edec24e19","86":"e6519d39da9d7fe34ebe","87":"bd94f1a2020d6e0d7885","88":"81abcf3082ab0cc7a76c","89":"daee46fdc00530b7ac60","90":"829cabcf540886f6f82d","91":"e1b75a791568be169644","92":"4dc02817fe871b71ce2c","93":"99184228a262586eb2ec","94":"4347d0bb3633af13ce5e","95":"2da0dac432e5a5fcf520","97":"1bdf8ad7b37a491986f0","98":"6b954d0b66852e3e24f3","99":"aee0b2ca5dd9f0524e05","100":"d134a46bcc2e2bc7b638","101":"51f262f73f2cab0c53e2","103":"7b8bd0e2416e437df665","104":"cc4a123d6a87d2cb19ba","105":"0d135906beae55ab395f","106":"9cb93e1468e768c3a1f4","107":"3bbfea8fc298ce9a6217","108":"b3ccc00e3919e802a43c","110":"2befec8dbef557214657","111":"cad749e99a1eef5dc8a8","112":"ba214b2a5167ad67112d","113":"83ae82d53f9057c7bb4d","114":"8e276b0a95646407e600","115":"823e497b0ff8ad7d5763","116":"10d91d92f535fef94115","117":"83e71359a34e1c353170","118":"606495c7b1c49295c91d","119":"83fb6381c5dd3ebc0ab4","120":"5d7d2d7dd5663ff61968","121":"777c5be97e3b272a112c","122":"5b98a1a3c3596e0b4673","123":"bed0724c70da534b73c6","124":"b76ea8416b537896a879","125":"9894db9814b9a93a6d50"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
